import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_EXAM_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => oldDoc,
  3: (oldDoc) => oldDoc,
  4: (oldDoc) => oldDoc,
  5: (oldDoc) => oldDoc,
  6: (oldDoc) => ({ ...oldDoc, signedAt: null, signedByUserId: null }),
  7: (oldDoc) => ({ ...oldDoc, nonBillable: false, nonBillableReason: null }),
  8: (oldDoc) => ({ ...oldDoc, amendments: [] }),
};
